import ActionFailException from "../utils/exceptions/ActionFailException";

const getMessage = ({ extensions: { errors }, message }) =>
	errors?.length > 0 ? errors[0].message || message : message;

const getExtensionsErrors = ({ path, code, extensions: { errors } }) =>
	errors?.length > 0
		? errors.map(error => `graphql:${path}.${error.type ? error.message : code}`)
		: [`graphql:${path}.${code}`];

export const getExceptionFields = originalError => [
	getMessage(originalError),
	originalError.code,
	getExtensionsErrors(originalError),
	originalError,
];

/** @TODO: Extract class to ActionFailException */
export class GraphQLNetworkException extends ActionFailException {}

export const netError = ({ networkError }) =>
	networkError ? new GraphQLNetworkException(networkError.message, networkError.code) : null;

export const gqlError = ({ graphQLErrors }) =>
	graphQLErrors?.length > 0
		? new ActionFailException(...getExceptionFields(graphQLErrors[0]))
		: null;

const getOperationError = err =>
	err instanceof ActionFailException ? err : gqlError(err) || netError(err);

export default getOperationError;
